<template>
  <el-dialog class="el-dialog-cus" v-if="visible" v-bind="attributes" :close-on-click-modal="false"
    :visible.sync="visible" append-to-body>
    <slot v-if="visibleSlot"></slot>
    <span v-if="diaText" class="diaText" :style="attributes.txtcenter ? 'text-align: center' : ''">{{ diaText }}</span>
    <div slot="footer" style="text-align: center">
      <el-button v-if="btnTxt[1]" @click="
        quXiao();
      close();
      " plain>{{ btnTxt[1] }}</el-button>
      <el-button @click="confirmMethods()" v-if="btnTxt[0]" type="primary">{{
        btnTxt[0]
      }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    config: Object,
  },
  data() {
    const {
      top = "20vh",
      width = "480px",
      title = "提示",
      txtcenter = false,
      btnTxt = [this.$fanyi("确定"), this.$fanyi("取消")],
    } = this.config || {};
    return {
      visible: false,
      attributes: {
        top,
        width,
        title,
        ...this.config,
      },
      btnTxt,
      visibleSlot: false,
      queRen: () => { },
      quXiao: () => { },
      diaText: null,
    };
  },
  watch: {
    // 为了可以更新弹窗参数加的这段代码
    visible() {
      this.attributes = {
        top: this.attributes.top,
        width: this.attributes.width,
        title: this.attributes.title,
        ...this.config,
      };
    },
  },
  computed: {},
  methods: {
    open(text, queRen, quXiao, btnTxt) {
      this.diaText = text;
      if (btnTxt) {
        this.btnTxt = btnTxt
      }

      queRen ? (this.queRen = queRen) : "";
      quXiao ? (this.quXiao = quXiao) : "";
      this.visible = true;
      this.visibleSlot = true;
      return this.$nextTick();
    },
    confirmMethods() {
      this.queRen();
    },
    close() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/mixin.scss";

.el-dialog-cus {
  /deep/.el-dialog {
    border-radius: 4px;
  }

  /deep/.el-dialog__title {
    line-height: 20px;
    font-size: 18px;
  }

  /deep/.el-dialog__header {
    text-align: center;
  }



  /deep/.el-dialog__body {
    padding: 10px 40px;
  }

  /deep/.el-dialog__footer {
    padding-bottom: 40px;

    .el-button {
      padding: 8px 16px;
      border-radius: 4px;
      font-size: 14px;
      line-height: 20px;
      margin: 0;

      &:first-child {
        border: 1px solid #edeff4;
        color: #333;
        margin-right: 12px;
      }

      &:last-child {
        background: #b4272d;
        color: white !important;
        margin: 0 !important;
      }
    }
  }

  .diaText {
    font-size: 18px;
    color: #000000;
    line-height: 26px;

    display: inline-block;
    width: 100%;
    margin-bottom: 30px;
  }
}
</style>